<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"></i> Ajouter profil</strong>
          </div>
          <b-form>
            <b-row>
              <b-col sm="6">
                <b-form-group
                  description="Libellé"
                  label="Libellé"
                  label-for="basicName"
                  :label-cols="3"
                  :horizontal="true"
                >
                  <b-form-input id="basicName" type="text" autocomplete="name"
                                :class="{hasError: errors.libelle !== ''}" v-model="libelle"></b-form-input>
                  <span class="field-error">{{ errors.libelle }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group
                  description="Code"
                  label="Code"
                  label-for="basicCode"
                  :label-cols="3"
                  :horizontal="true"
                >
                  <b-form-input id="basicCode" type="text" :class="{hasError: errors.code !== ''}"
                                v-model="code"></b-form-input>
                  <span class="field-error">{{ errors.code }}</span>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-group
                  description="Libellé à afficher"
                  label="Libellé à afficher"
                  label-for="libelle_affiche"
                  :label-cols="3"
                  :horizontal="true"
                >
                  <b-form-input id="libelle_affiche" type="text" autocomplete="name"
                                :class="{hasError: errors.libelle_affichage !== ''}" v-model="libelle_affichage"></b-form-input>
                  <span class="field-error">{{ errors.libelle_affichage }}</span>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group description="Structure"
                              label="Structure"
                              label-for="basicStructure"
                              :label-cols="3"
                              :horizontal="true">
                  <multiselect selectLabel='Appuyer sur entrer pour sélectionner'
                                 selectedLabel='Sélectionné'
                                 deselectLabel='Appuyer sur entrer pour désélectionner'
                                 :close-on-select="false"
                                 v-model="structures"
                                 tag-placeholder="Choisissez une/des structure(s)"
                                 placeholder="Par défaut Tous"
                                 label="name"
                                 track-by="code"
                                 :options="structuresOptions"
                                 :multiple="true"
                                 :taggable="true">
                    </multiselect>
                  <!-- <b-form-select v-model="structure" :options="structuresOptions"> -->
                  </b-form-select>
                  <span class="field-error">{{ errors.structure }}</span>
                </b-form-group>
              </b-col>
            </b-row>
            <b-card no-body>
              <div class="card-smallHeader card-header-action" v-b-toggle.collapse-rules>
                <span>Droits</span>
                <div class="card-header-actions">
                    <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
                    <span class="when-closed">
                      <i class="icon-arrow-up"></i>
                    </span>
                </div>
              </div>
              <b-collapse id="collapse-rules" style="margin-top:20px">
                <b-card-body class="small-padding">
                  <b-card v-for="group in droitsOptions" :key="group.id" no-body>
                    <div class="card-smallHeader card-header-action" v-b-toggle="'collapse' + group.id">
                      <!-- <b-form-group> -->
                        <b-form-checkbox-group v-model="checkedDroits" class="inline">
                          <b-form-checkbox :value="group.id">{{ group.libelle }}</b-form-checkbox>
                        </b-form-checkbox-group>
                      <!-- </b-form-group> -->
                      <div class="card-header-actions">
                      <span class="when-opened">
                        <i class="icon-arrow-down"></i>
                      </span>
                          <span class="when-closed">
                        <i class="icon-arrow-up"></i>
                      </span>
                      </div>
                    </div>
                    <b-collapse :id="'collapse' + group.id" style="margin-top:20px">
                      <b-card-body class="small-padding">
                        <b-form-group>
                          <b-form-checkbox-group v-model="checkedDroits">
                            <b-row>
                              <b-col sm="4" v-for="child in group.children" :key="child.id">
                                <b-card header-tag="header" class="mb-1" no-body>
                                  <h6   class="card-smallHeader">
                                    <b-form-checkbox :value="child.id" v-on:change="changeDroit(child.id)">
                                      {{ child.libelle }}
                                    </b-form-checkbox>
                                  </h6>
                                  <b-card-body class="small-padding">
                                    <b-form-checkbox v-for="droit in child.children"
                                                     :value="droit.id"
                                                     v-on:change="changeDroit(droit.id)"
                                                     :key="droit.id"
                                                     class="col-md-12">
                                      {{ droit.libelle }}
                                    </b-form-checkbox>
                                  </b-card-body>
                                </b-card>
                              </b-col>
                            </b-row>
                          </b-form-checkbox-group>
                        </b-form-group>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body>
              <div class="card-smallHeader card-header-action" v-b-toggle.collapse-treatments>
                <span>Traitements</span>
                <div class="card-header-actions">
                  <!-- <b-link class="card-header-action btn-minimize" v-b-toggle.collapse-treatments variant="primary"> -->
                    <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
                    <span class="when-closed">
                      <i class="icon-arrow-up"></i>
                    </span>
                  <!-- </b-link> -->
                </div>
              </div>
              <b-collapse id="collapse-treatments" style="margin-top:20px">
                <b-card-body class="small-padding">
                  <b-form-checkbox-group style="column-count: 2;" v-model="checkedTraitements" stacked>
                    <b-form-checkbox v-for="traitement in traitements"
                                     :value="traitement.id"
                                     :key="traitement.id">
                      {{ traitement.libelle }}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body>
              <div class="card-smallHeader card-header-action" v-b-toggle.collapse-oags>
                <span>OAGS</span>
                <div class="card-header-actions">
                  <!-- <b-link class="card-header-action btn-minimize" v-b-toggle.collapse-oags variant="primary"> -->
                    <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
                    <span class="when-closed">
                      <i class="icon-arrow-up"></i>
                    </span>
                  <!-- </b-link> -->
                </div>
              </div>
              <b-collapse id="collapse-oags" style="margin-top:20px">
                <b-card-body class="small-padding">
                  <b-form-checkbox-group style="column-count: 2;" v-model="checkedOags" stacked>
                    <b-form-checkbox v-for="oag in oags"
                                     :value="oag.id"
                                     :key="oag.id">
                      {{ oag.code }}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body>
              <div class="card-smallHeader card-header-action" v-b-toggle.collapse-oaps>
                <span>OAPS</span>
                <div class="card-header-actions">
                  <!-- <b-link class="card-header-action btn-minimize" v-b-toggle.collapse-oaps variant="primary"> -->
                    <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
                    <span class="when-closed">
                      <i class="icon-arrow-up"></i>
                    </span>
                  <!-- </b-link> -->
                </div>
              </div>
              <b-collapse id="collapse-oaps" style="margin-top:20px">
                <b-card-body class="small-padding">
                  <b-form-checkbox-group style="column-count: 2;" v-model="checkedOaps" stacked>
                    <b-form-checkbox v-for="oap in oaps"
                                     :value="oap.id"
                                     :key="oap.id">
                      {{ oap.code }} - {{ oap.libelle }}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body>
              <div class="card-smallHeader card-header-action" v-b-toggle.collapse-type>
                <span>Types de dossier visibles par le profil</span>
                <div class="card-header-actions">
                  <!-- <b-link class="card-header-action btn-minimize" v-b-toggle.collapse-type variant="primary"> -->
                  <span class="when-opened">
                      <i class="icon-arrow-down"></i>
                    </span>
                  <span class="when-closed">
                      <i class="icon-arrow-up"></i>
                    </span>
                  <!-- </b-link> -->
                </div>
              </div>
              <b-collapse id="collapse-type" style="margin-top:20px">
                <b-card-body class="small-padding">
                  <b-form-checkbox-group style="column-count: 2;" v-model="checkedTypesDossier" stacked>
                    <b-form-checkbox v-for="type in typesDossier"
                                     :value="type.id"
                                     :key="type.id">
                      {{ type.libelle }}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-card-body>
              </b-collapse>
            </b-card>
            <div slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary" style="margin-top:20px">
                <i class="fa fa-arrow-left"></i> Liste des profils
              </b-button>
              <b-button type="button" @click="saveProfil" size="md" class="pull-right" variant="primary"
                        style="margin-top:20px">
                <i class="fa fa-save"></i> Enregistrer
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken} from '@/utils/auth';
  import {isEmpty} from "@/utils/fileHelper";
  import Multiselect from 'vue-multiselect';
  
  export default {
    components: {
      Multiselect
    },
    data() {
      return {
        libelle: '',
        libelle_affichage: '',
        code: '',
        structuresOptions: [],
        structures: [],
        selectedStructures: [],
        droitsOptions: [],
        droitSelected: [],
        checkedDroits: [],
        traitements: [],
        checkedTraitements: [],
        oags: [],
        checkedOags: [],
        oaps: [],
        checkedOaps: [],
        typesDossier: [],
        checkedTypesDossier: [],
        errors: {
          libelle: '',
          libelle_affichage: '',
          code: '',
          structure: ''
        }
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken();
      this.$axios.defaults.headers.common['Accept'] = 'application/json';
      this.$axios.defaults.headers.common['Provider'] = getProvider();
      this.getStructures();
      this.getTypes();
      this.allHabilitations();
      this.allTraitements();
      this.allOags();
      this.allOaps();
    },
    watch: {
      structures: function() {
        if (this.structures) {
          this.selectedStructures = this.structures.map( item => item.code);
        } else {
          this.selectedStructures = [];
        }
      },
    },
    methods: {
      allHabilitations() {
        this.$axios
          .get('/administration/droits_children')
          .then(response => {
            let droits = response.data.droits;
            for (let i = 0; i < droits.length; i++) {
              this.droitsOptions.push({
                id: droits[i].id,
                libelle: droits[i].libelle,
                libelle_technique: droits[i].libelle_technique,
                espace_id: droits[i].espace_id,
                module_id: droits[i].module_id,
                parent_id: droits[i].parent_id,
                children: droits[i].children,
              });
            }
          });
      },
      allTraitements() {
        this.$axios
          .get('/administration/traitements')
          .then(response => {
            this.traitements = response.data.traitements;
          });
      },
      allOags() {
        this.$axios
          .get('/referentielClient/oag')
          .then(response => {
            this.oags = response.data.oags;
          });
      },
      allOaps() {
        this.$axios
          .get('/referentielClient/oap')
          .then(response => {
            this.oaps = response.data.oaps;
          });
      },
      saveProfil() {
        if (this.validateData()) {
          this.$store.commit('IS_LOADING', true);
          let self = this;
          let dataPost = {};
          dataPost.libelle = this.libelle;
          dataPost.libelle_affichage = this.libelle_affichage;
          dataPost.code = this.code;
          dataPost.structureIds = this.selectedStructures;
          dataPost.droits = [...new Set(this.checkedDroits)];
          dataPost.traitements = this.checkedTraitements;
          dataPost.oags = this.checkedOags;
          dataPost.oaps = this.checkedOaps;
          dataPost.typeDossierIds = this.checkedTypesDossier;
          this.$axios
            .post('/administration/profiles', dataPost)
            .then(() => {
              this.$store.commit('IS_LOADING', false);
              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Création avec succès',
                text: 'Le profil ' + dataPost.libelle + ' a bien été créé',
                showConfirmButton: false,
                timer: 5000
              });
              this.returnBack();
            })
            .catch((error) => {
              console.log(error)
              self.$store.commit('IS_LOADING', false);
              let textError = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI'
              if (error.response.status === 409) {
                textError = 'Le code du profil est déjà utilisé'
                this.errors.code = error.response.message;
              }
              self.$store.commit('IS_LOADING', false)
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: textError,
                showConfirmButton: false,
                timer: 5000
              })
            });
        } else {
          this.$swal({
            position: 'top',
            type: 'warning',
            title: 'Attention !!',
            text: 'Des données obligatoires sont manquantes',
            showConfirmButton: false,
            timer: 5000
          });
        }
      },
      returnBack() {
        this.$router.push({path: '/administration/profiles', query: {filter: this.$route.query.filter}});
      },
      validateData() {
        this.clearErrors();
        let valid = true;
        if (this.libelle === '') {
          this.errors.libelle = 'Le libellé est obligatoire';
          valid = false;
        }
        if (this.libelle_affichage === '') {
          this.errors.libelle_affichage = 'Le libellé à afficher est obligatoire';
          valid = false;
        }
        if (this.code === '') {
          this.errors.code = 'Le code est obligatoire';
          valid = false;
        }
        if (isEmpty(this.selectedStructures)) {
          this.errors.structure = 'Le choix d\'au moins une structure est obligatoire';
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.libelle = '';
        this.errors.code = '';
        this.errors.structure = '';
      },
      changeDroit(droitId) {
        this.setAncestorsIds(droitId);
      },
      getStructures() {
        this.$axios
          .get("/administration/structures")
          .then(response => {
            for(let structures of response.data.structures){
              this.structuresOptions.push({code: structures.id, name: structures.libelle})
              // this.structuresOptions.push({value: structures.id, text: structures.libelle})
            }
          })
          .catch(() => {
            this.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Un probléme est survenue, merci de contacter l\'administrateur',
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
      setAncestorsIds(droitId) {
        this.$axios
          .get('/administration/droits_ancestors/' + droitId)
          .then(response => {
            const ancestors = response.data.ancestors;
            for (let i = 0; i < ancestors.length; i++) {
              this.checkedDroits.push(ancestors[i]);
            }
            this.checkedDroits = [...new Set(this.checkedDroits)];
          });
      },
      getTypes() {
        let self = this;
        this.$axios
          .get("/espaceGestion/dossier/getAllType")
          .then(response => {
            this.typesDossier = response.data.data;
          })
          .catch(() => {
            self.handleError(self);
          });
      },
    }
  };
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
    display: none;
  }

  .traitements {
    -webkit-column-count: 2; /* Chrome, Safari, Opera */
    -moz-column-count: 2; /* Firefox */
    column-count: 2;
  }
</style>
